export const INVALID_EMAIL = 'Invalid email address.';
export const MUST_MATCH_EMAIL = 'Email address must match.';
export const MUST_MATCH_PASSWORD = 'Password must match.';
export const LOGIN_EMAIL_REQUIRED = 'Please enter an email';
export const LOGIN_PASSWORD_REQUIRED = 'Please enter a password';
export const REQUIRED = 'Required.';
export const MUST_MATCH = 'Must match.';
export const INVALID_VALUE = 'Invalid.';



// WEBPACK FOOTER //
// ./src/helpers/errorMessages.js